import styled from 'styled-components';

import { FiMenu } from "react-icons/fi";
import { VscChromeClose } from "react-icons/vsc";

export const IconFiMenu = styled(FiMenu)`
    width:30px;
    height:30px;


`
export const IconVscChromeClose = styled(VscChromeClose)`
    width:30px;
    height:30px;


`
export const DivMenuOpMobile = styled.div`
margin:20px 0;
border-top:1px solid lightgrey;
width:100%;
height:40px;


`
